<script>

    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'
    import { MerchandiseStore, MerchandisesStore } from '../stores'

    import MerchandisesService from '../$services/merchandises.service'
    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

    const dispatch = createEventDispatcher()

   let loading = false
   
    async function deleteMerchandise() {
    
        loading = true
        const resp = await MerchandisesService.deleteMerchandise($MerchandiseStore._id)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        MerchandisesStore.remove($MerchandiseStore._id)
        MerchandiseStore.set(null)

        toast({message: 'Mercancia borrada', type: 'is-success'})
        dispatch('deleted')
    }

</script>

{#if $MerchandiseStore}
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <Button on:click={() => MerchandiseStore.modalUpdate($MerchandiseStore)} icon="edit" text="Actualizar" color="primary" size="small" />
                <ButtonDelete on:confirm={ deleteMerchandise } {loading} />
            </div>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Alias" value={ $MerchandiseStore.alias } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Items" value={ $MerchandiseStore.items } />
        </div>
        <div class="column">
            <Value label="Valor" value={ NumeralMethods.cash($MerchandiseStore.value) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Product" value={ $MerchandiseStore.productName } />
        </div>
        <div class="column">
            <Value label="Código" value={ $MerchandiseStore.productCode } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Unidad de medida" value={ $MerchandiseStore.unitName } />
        </div>
        <div class="column">
            <Value label="Código" value={ $MerchandiseStore.unitCode } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Peso" value={ $MerchandiseStore.weight } postfix="KG" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Description" value={ $MerchandiseStore.description } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de registro" value={ DateMethods.dateTimeLarge($MerchandiseStore.created) } />
        </div>
    </div>
{/if}